"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductUnitOfMeasure = void 0;
const common_1 = require("../../common");
class ProductUnitOfMeasure extends common_1.MongoDocument {
}
exports.ProductUnitOfMeasure = ProductUnitOfMeasure;
//# sourceMappingURL=product-unit-of-measure.model.js.map